 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-065bee24":"7957ad32","chunk-0a3e9ff8":"19586382","chunk-0be3b518":"5c55fda6","chunk-1070b4b5":"16a70417","chunk-130f66f8":"faf05fcd","chunk-15cc9cc2":"b78ece1e","chunk-17fd5b09":"5fe3a249","chunk-1e3d249a":"ce581fe7","chunk-21604110":"19222dac","chunk-2870ea9b":"e81bdbba","chunk-00ae505a":"aaa02bf8","chunk-27c8feca":"5c9a5d67","chunk-28b790b4":"9c0413cb","chunk-2aa7e584":"a4338d13","chunk-2e51e5a4":"5343df46","chunk-7f85e16e":"e8018a3e","chunk-fe37bfae":"c4537dbf","chunk-380dfbc5":"da76f2cf","chunk-402c0018":"749d634b","chunk-444b39c4":"5cb01e1b","chunk-5484b4e2":"48f18bbb","chunk-57dfe0f9":"29c19c11","chunk-5d548d57":"7e4fb6a4","chunk-63618cac":"a025708e","chunk-6a8b8a16":"c2388f3a","chunk-6ea76f10":"333584e2","chunk-78effc44":"ab28bd3e","chunk-8a62f338":"eb70ee1b","chunk-931175da":"eccf3fb9","chunk-a1a042dc":"66236a5a","chunk-aa487970":"f877eb9a","chunk-b2192fe8":"507a0a14","chunk-b4150c30":"5e711f38","chunk-bd05d974":"4f157805","chunk-be5c9d1a":"e0a76b65","chunk-d3a1082c":"652ea9a9","chunk-d81979fa":"ba00b005","chunk-e85f37f0":"d888ae23"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-065bee24":1,"chunk-0a3e9ff8":1,"chunk-0be3b518":1,"chunk-1070b4b5":1,"chunk-130f66f8":1,"chunk-15cc9cc2":1,"chunk-17fd5b09":1,"chunk-1e3d249a":1,"chunk-21604110":1,"chunk-2870ea9b":1,"chunk-00ae505a":1,"chunk-27c8feca":1,"chunk-28b790b4":1,"chunk-2aa7e584":1,"chunk-7f85e16e":1,"chunk-fe37bfae":1,"chunk-380dfbc5":1,"chunk-402c0018":1,"chunk-444b39c4":1,"chunk-5484b4e2":1,"chunk-57dfe0f9":1,"chunk-5d548d57":1,"chunk-63618cac":1,"chunk-6a8b8a16":1,"chunk-6ea76f10":1,"chunk-78effc44":1,"chunk-8a62f338":1,"chunk-931175da":1,"chunk-a1a042dc":1,"chunk-aa487970":1,"chunk-b2192fe8":1,"chunk-b4150c30":1,"chunk-bd05d974":1,"chunk-be5c9d1a":1,"chunk-d3a1082c":1,"chunk-d81979fa":1,"chunk-e85f37f0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-065bee24":"5edb392b","chunk-0a3e9ff8":"09d27f6a","chunk-0be3b518":"8a0bbf10","chunk-1070b4b5":"ea749b71","chunk-130f66f8":"1b82cce9","chunk-15cc9cc2":"9e102d7b","chunk-17fd5b09":"05cbe693","chunk-1e3d249a":"f0beda0c","chunk-21604110":"72f908b4","chunk-2870ea9b":"463ce4b9","chunk-00ae505a":"20236634","chunk-27c8feca":"7b6c2261","chunk-28b790b4":"9657ecbb","chunk-2aa7e584":"636e604c","chunk-2e51e5a4":"31d6cfe0","chunk-7f85e16e":"d9430ace","chunk-fe37bfae":"0e20517c","chunk-380dfbc5":"ad3e14e8","chunk-402c0018":"af43d5fc","chunk-444b39c4":"222018f0","chunk-5484b4e2":"9136dad5","chunk-57dfe0f9":"0e6f71cb","chunk-5d548d57":"bd9c77bd","chunk-63618cac":"e9fbcabb","chunk-6a8b8a16":"c87f53d1","chunk-6ea76f10":"f2afa310","chunk-78effc44":"f6628a39","chunk-8a62f338":"62194882","chunk-931175da":"2ffaadae","chunk-a1a042dc":"756e4b52","chunk-aa487970":"f1a49d8c","chunk-b2192fe8":"1c1db13f","chunk-b4150c30":"4b5e51f0","chunk-bd05d974":"32a5baed","chunk-be5c9d1a":"01214c6d","chunk-d3a1082c":"3c1c0a08","chunk-d81979fa":"268f522b","chunk-e85f37f0":"282a03d9"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/college_new/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
